// Every host of the copilot paints this, or its fades show as a lighter band.
export const COPILOT_SURFACE_CLASSES = "bg-gray-50 dark:bg-gray-850"

// Sits directly above the composer so the transcript dissolves into the panel
// instead of ending on a hairline where the two surfaces meet.
export const COPILOT_COMPOSER_FADE_CLASSES =
	"pointer-events-none absolute inset-x-0 bottom-full z-10 h-6 bg-gradient-to-t from-gray-50 via-gray-50/80 to-transparent dark:from-gray-850 dark:via-gray-850/80"
